<template>
  <!-- TODO: This will be updated with animations later on, see #25dum6y -->
  <div class="splash-screen">
    <a-typography-title class="splash-screen__text" :level="2">
      {{ t("Loading...") }}
    </a-typography-title>
  </div>
</template>

<style lang="scss">
.splash-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100vh - $layout-header-height);
  &__text {
    font-weight: $font-regular;
  }

  @media screen and (max-width: $screen-md) {
    height: 100vh;
  }
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  setup() {
    const t = useI18n().t;

    return { t };
  },
});
</script>
